import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { reducers as globalReducers } from '@nextiva/global-store';

import { rolesPermissions } from 'containers/pages/Roles/redux';
import { teamsReduxReducer } from 'containers/pages/Teams/redux';
import resetData from 'containers/pages/ResetDataStatus/duck';
import pageMeta from 'containers/App/Page/duck';
import roles from 'containers/pages/Roles/AdvancedRoles/duck';
import users from 'containers/pages/ManageUsers/duck';
import licenses from 'containers/pages/ManageUsers/UserApplications/duck';
import products from 'containers/pages/Roles/AdvancedRoles/ManageRole/RoleProducts/duck';
import productResources, {
  productActions,
  productSettings,
} from 'containers/pages/Roles/AdvancedRoles/ManageRole/ModelsPermissions/duck';
import options from 'containers/VoiceMail/reducers/options';
import advanced from 'containers/VoiceMail/reducers/advanced';
import formsState from 'containers/VoiceMail/reducers/formsState';
import { globalPolicyDecisionRequestState } from 'globalReducers/globalPolicyDecisionRequest/globalPolicyDecisionRequestReducer';
import { globalAccountV2SummaryState } from 'globalReducers/globalAccountV2Summary/globalAccountV2SummaryReducer';

const createRootReducer = () => {
  return combineReducers({
    ...globalReducers,
    rolesPermissions,
    teamsReduxReducer,
    form,
    roles,
    users,
    licenses,
    products,
    productResources,
    productActions,
    productSettings,
    pageMeta,
    resetData,
    options,
    advanced,
    formsState,
    globalPolicyDecisionRequestState,
    globalAccountV2SummaryState,
  });
};

export default createRootReducer;
